<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div *ngFor="let telefonnummer of this.data?.telefonnummern; let i=index;">
    <common-ui-telefonnummer (dataChange)="dataChange.emit(data)"
                             (removeTelefonnummerClicked)="removeTelefonnummer($event)" [data]="telefonnummer" [index]="i"
                             [readonly]="readonly"
                             [showRemoveTelefonnummerButton]="data?.telefonnummern?.length > 1"
                             [stammdatenTelefonnummern]="stammdatenTelefonnummern"></common-ui-telefonnummer>
  </div>

  <div *ngIf="!readonly && data?.telefonnummern?.length < maxTelefonnummern" class="form-row mb-3x">
    <div class="col-12 d-flex justify-content-end">
      <button (click)="addTelefonnummer()" class="btn btn-light" id="addTelefonnummer{{index}}"
              type="button">
        <em class="icon icon-svg icon-fi-hinzufuegen"></em>
        {{ 'COMMON_UI.KOMMUNIKATIONSMITTEL.ADD_TELEFONNUMMER' | translate }}
      </button>
    </div>
  </div>

  <common-ui-internet (dataChange)="dataChange.emit(data)" *ngIf="!disableInternet" [(data)]="data.internet"
                      [readonly]="readonly" [stammdatenInternetadressen]="stammdatenInternetadressen">
  </common-ui-internet>

</form>
